/**
 * Engine version, recorded on every Determination (§8). A source constant —
 * the engine cannot read package.json because it does no I/O. Keep in sync
 * with packages/engine/package.json; the release checklist owns that.
 */
export const ENGINE_VERSION = "0.1.0";
